<template>
  <footer class="bottom-info" :class="{ 'home-info': isHome }">
    <div class="top">
      <router-link
        v-for="item in links"
        :key="item.name"
        :to="item.to"
        :class="{ active: isActive(item.to) }"
      >
        {{ item.name }}
      </router-link>
    </div>
    <p>版权所有 江苏畅想之星信息技术有限公司</p>
  </footer>
</template>

<script>
export default {
  name: 'BottomInfo',
  data() {
    return {
      links: [
        {
          name: '关于我们',
          to: { path: '/AboutUs', query: { type: 'about' } },
        },
        {
          name: '联系我们',
          to: { path: '/AboutUs', query: { type: 'contactUs' } },
        },
        // {
        //   name: '免责声明',
        //   to: { path: '/AboutUs', query: { type: 'disclaimer' } },
        // },
        {
          name: '本站分类法',
          to: { path: '/Classify' },
        },
        // {
        //   name: '本站大数据',
        //   to: { path: '/BigData' },
        // },
      ],
    }
  },
  methods: {
    isActive(item) {
      const route = this.$route
      const paths = this.links.map((item) => item.to.path)
      if (!paths.includes(route.path)) return false
      if (item.path === '/AboutUs') return item.query.type === route.query.type
      return route.path === item.path
    },
    aboutPath(type) {
      return {
        path: '/AboutUs',
        query: { type },
      }
    },
  },
  computed: {
    isHome() {
      return this.$route.meta.index === 0
    },
  },
}
</script>

<style lang="scss" scoped>
.bottom-info {
  background: #333;
  padding: 20px 0;
  height: 100px;
  .top {
    width: 300px;
    // width: 466px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  a {
    color: #ccc;
    text-decoration: none;
  }
  a:hover {
    color: $mainColor;
  }
  p {
    text-align: center;
    color: #666;
  }
  .active {
    color: $mainColor;
  }
}
.home-info {
  background-color: #fff;
  a,
  p {
    color: #999;
  }
}
</style>
